import React from 'react'
import { useMantineTheme } from '@mantine/core'
import mark from '../assets/brand/livehq-mark.svg'
import wordmarkDark from '../assets/brand/livehq-wordmark-dark.svg'
import wordmarkLight from '../assets/brand/livehq-wordmark-light.svg'

const BrandLogo = ({
	variant = 'wordmark',
	scheme = 'auto',
	height = 30,
	width = 'auto',
	alt = 'LiveHQ',
	style,
	...rest
}) => {
	const theme = useMantineTheme()
	const resolvedScheme = scheme === 'auto' ? theme.colorScheme : scheme
	const src =
		variant === 'mark'
			? mark
			: resolvedScheme === 'dark'
				? wordmarkLight
				: wordmarkDark

	return (
		<img
			src={src}
			alt={alt}
			style={{
				display: 'block',
				height,
				width,
				maxWidth: '100%',
				objectFit: 'contain',
				...style,
			}}
			{...rest}
		/>
	)
}

export default BrandLogo
